import React, { useState } from 'react';
import ButtonsGeneric from '../../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../../components/NovoSistema/ContainerSection';
import { WrapperInputsNewSystem } from '../../../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import ButtonOptions from '../../../../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../../../../components/NovoSistema/HeaderButtons';
import SelectAndOptions from '../../../../../../../../components/NovoSistema/SelectAndOptions';
import InputDate from '../../../../../../../../components/NovoSistema/InputDate';
import DoubleInput from '../../../../../../../../components/NovoSistema/DoubleInput';
import InputText from '../../../../../../../../components/NovoSistema/InputText';

export default function RequisicaoDeMaterialFilter() {
  const [option, setOption] = useState('Filtro');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Filtro"
          border="#DFB007"
          active={option === 'Filtro' ? true : false}
          yourFunction={() => setOption('Filtro')}
        />
      </HeaderButtons>
      {option === 'Filtro' && (
        <ContainerSection>
          <WrapperInputsNewSystem>
            <InputText title="Número Documento Inicial" id="NumeroDocumentoInicial" widthPercentage="20%" />
            <InputText title="Número Documento Final" id="NumeroDocumentoFinal" widthPercentage="20%" />
            <InputDate title="Emissão Inicial" id="EmissaoInicial" widthPercentage="20%" />
            <InputDate title="Emissão Final" id="EmissaoFinal" widthPercentage="20%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <DoubleInput title="Produto" id="Produto" widthPercentage="40%" />
            <InputDate title="Previsão de Entrega Inicial" id="PrevisaoDeEntregaInicial" widthPercentage="20%" />
            <InputDate title="Previsão de Entrega Final" id="PrevisaoDeEntregaFinal" widthPercentage="20%" />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <SelectAndOptions title="Setor" id="Setor" optionsArray={['']} widthPercentage="30%" />
            <SelectAndOptions
              title="Tipo Relatório"
              id="TipoRelatorio"
              optionsArray={['Analítico', 'Sintético']}
              widthPercentage="30%"
            />
            <SelectAndOptions
              title="Situação"
              id="Situacao"
              optionsArray={['', 'Aberta', 'Finalizada Parcial', 'Finalizada', 'Finalizada Manualmente', 'Cancelada']}
              widthPercentage="30%"
            />
          </WrapperInputsNewSystem>
          <ButtonsGeneric>
            <button className="normal">Limpar</button>
          </ButtonsGeneric>
        </ContainerSection>
      )}
    </div>
  );
}
